// export const API_ENDPOINT_URL = 'http://localhost:8007';
export const API_ENDPOINT_URL = process.env.REACT_APP_API_ENDPOINT_URL;
//----------------------------------------------------------------
// export const API_ENDPOINT_URL = 'http://192.168.1.124:8007';
//----------------------------------------------------------------
// export const API_ENDPOINT_URL =
//   'https://876c-2001-44c8-42cc-2b5b-ec7a-8907-fb2-6047.ngrok-free.app';
